import { PartialGrade } from './partial-grade.model';

export class PartialGradeCommand {
    id?: number;
    grade: {
        id: number;
    };
    comment: string;

    constructor(entity: PartialGrade, sendId: boolean = false) {
        if (!entity) {
            throw new Error(`Can not create a PartialGradeCommand without input!`);
        }

        if (sendId) {
            this.id = Number.parseInt(entity.id, 10);
        }

        this.grade = entity.gradeId
            ? {
                  id: Number.parseInt(entity.gradeId, 10),
              }
            : null;
        this.comment = entity.comment;
    }
}
